import React from 'react';
import Page from "../../containers/Page/Page";
import { Box, Typography, TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Grid } from "@material-ui/core";
import { Pagination } from '@material-ui/lab';
import SearchField from "../../components/SearchField";
import { useHistory } from "react-router-dom";
import { api } from '../../services/api';
import { Helpers } from '../../utils/Helpers';

interface IData {
    data: {
        codusuario: string;
        nome: string;
        email: string;
        papel: {
            nome: string;
        }[];
    }[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

function Usuarios() {

    const history = useHistory();
    const query = new URLSearchParams(history.location.search);

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [search, setSearch] = React.useState<string>(query.get('search') || '');
    const [data, setData] = React.useState<IData>();

    /**
     * Ao carregar a página.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar usuarios.
     * @param page 
     */
    async function handleFetch(page: number = Number(query.get('page')) || 1) {
        setLoading(true);
        try {
            const url = `/usuarios?search=${search}&page=${page}`;
            const response = await api.get(url);
            history.push(url);
            setData(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    /**
     * Pesquisar com ENTER.
     * @param event 
     */
    function handleSearchKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (event.key === 'Enter') {
            handleFetch(1);
        }
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Usuários
                </Typography>
            </Page.Title>
            {data &&
                <Page.Section>
                    <Page.Toolbar>
                        <SearchField
                            placeholder="Pesquisa"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            onKeyUp={(event) => handleSearchKeyUp(event)}
                            onClick={() => handleFetch(1)}
                        />
                    </Page.Toolbar>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Nome</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Papel</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.data.map((usuario, index) => (
                                        <TableRow
                                            key={index}
                                            hover={true}
                                            onClick={() => history.push(`/usuarios/${usuario.codusuario}`)}
                                        >
                                            <TableCell>{usuario.codusuario}</TableCell>
                                            <TableCell>{usuario.nome}</TableCell>
                                            <TableCell>{usuario.email}</TableCell>
                                            <TableCell>{usuario.papel[0] ? usuario.papel[0].nome : ''}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box p={2}>
                            <Grid container justifyContent="center">
                                <Pagination
                                    page={data.current_page}
                                    count={data.last_page}
                                    onChange={(_event, page) => handleFetch(page)}
                                    color="secondary"
                                />
                            </Grid>
                        </Box>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default Usuarios;